import {createFileRoute, stripSearchParams} from '@tanstack/react-router'
import {type} from 'arktype'

import privateRoute from '@/auth/middleware/privateRoute'
import {fallbackToDefault} from '@/utils/schema/fallback'

const DEFAULT_VALUES = {
  page: 1,
}

const flightBookingsSearchSchema = type({
  page: fallbackToDefault(type('number > 0'), DEFAULT_VALUES.page),
})

export const Route = createFileRoute('/_account/flight-bookings/')({
  validateSearch: flightBookingsSearchSchema,
  search: {
    middlewares: [stripSearchParams(DEFAULT_VALUES)],
  },
  beforeLoad: ({context, location}) => {
    privateRoute(context.store, location.href)
  },
})
